export class Airline {
    displayDescription: string;
    fsCode: string;
    hintDescription: string;
}
